import React from "react";
import { RxCornerBottomLeft } from "react-icons/rx";

const Products = ({ data }) => {
  return (
    <ul>
      <li className="header">
        <div className="product media">상품이미지</div>
        <div className="product name">상품명</div>
        <div className="product price">상품가격</div>
        <div className="product quantity">개수</div>
      </li>
      {data && data.length > 0 ? (
        data.map((product) => (
          <li>
            <div className="product media">
              <img
                src={
                  product?.productImgSrc
                    ? imgHandler(product.productImgSrc)
                    : "/img/icon_function_3.png"
                }
                alt={product.productName}
              />
            </div>
            <div className="product name">{product.productName}</div>
            <div className="product price">{formatNumber(product?.price)}원</div>
            <div className="product quantity">{product.quantity}</div>
            {product.options && product.options.length > 0 && (
              <div className="options">
                {product.options.map((opt) => (
                  <div>
                    {/* <i>
                      <RxCornerBottomLeft />
                    </i> */}
                    <span>{opt.optionName}</span>
                    <span>+{formatNumber(opt.optionPrice)}원</span>
                  </div>
                ))}
              </div>
            )}
          </li>
        ))
      ) : (
        <li>주문상품이 존재하지 않습니다.</li>
      )}
    </ul>
  );
};

export default Products;
